'use strict';

module.exports = function addKeyPressEventListener(element, keyCode, handler) {
  element.addEventListener('keydown', function (e) {
    if (e.keyCode !== keyCode) { return; }
    handler(e);
  });
};
